import styled, { css } from 'styled-components';

import { messagesRegular } from 'styles/mixins/fonts';

export const TotalCard = styled.div`
  padding: 16px;
  display: flex;
  border-radius: 16px;
  flex-direction: column;
  ${({ theme }) => css`
    gap: ${theme.responsive.isDesktop ? 16 : 8}px;
    border: 1px solid ${theme.colors.grey.secondary.standard};
  `}
`;

export const Divider = styled.p`
  height: 1px;
  width: 100%;
  margin: 8px 0;
  background-color: ${({ theme }) => theme.config.common.border};
`;

export const Title = styled.p`
  ${messagesRegular};
  font-weight: 600;
  line-height: 24px;
`;
